import * as React from "react";
import Ajax from "../../Ajax";
import swal from "sweetalert";
import DownstairsPlan from "./floorPlan/DownstairsPlan";
import FirstFloorPlan from "./floorPlan/FirstFloorPlan";
import TentPlan from "./floorPlan/TentPlan";


interface IFormProps {

}
interface MyStates {
    places_from_date: any;
    places_to_date: any;
    places: any;
    sumplaces:number;
}
export default class AvailableRooms extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {
            places_from_date: '',
            places_to_date: '',
            places: [],
            sumplaces:0
        }
    }

    private updateDates(e, type){
        if( type == 'from'){
            this.setState({places_from_date: e.target.value}, () => this.loadPlaces())
        }
        if( type == 'to'){
            this.setState({places_to_date: e.target.value}, () => this.loadPlaces())
        }
    }

    private loadPlaces() {
        if( this.state.places_from_date != '' && this.state.places_to_date != '' ){
            var ajax = new Ajax(window.location.origin+ '/api/ordering/loadPlaces');
            ajax.doPost({
                from: this.state.places_from_date,
                to: this.state.places_to_date,
                session_id: 'new',
                isdisabled: false
            }).then((response) => {
                console.log(response);
                if( response.status == 'success' ){
                    let sumplaces = 0;
                    Object.keys(response.places).map((i) => {
                        let p = response.places[i]
                        sumplaces += p.capacity
                    })
                    this.setState({
                        places: response.places,
                        sumplaces: sumplaces
                    })
                } else {
                    swal({
                        title: "Hiba történt!",
                        text: response.message,
                        icon: "error",
                    });
                }
            })
        }
    }

    public Rooms (){

        let downstairs_rooms_ids = [];
        let firstfloor_rooms_ids = [];
        let tent_rooms_ids = [];
        Object.keys(this.state.places).map((i) => {
            let place = this.state.places[i]
            if('downstairs' == place.storey){
                downstairs_rooms_ids.push(place.id);
            }
            if('first_floor' == place.storey){
                firstfloor_rooms_ids.push(place.id);
            }
            if('tent_site' == place.storey){
                tent_rooms_ids.push(place.id);
            }
        });

        return (
            <div className="row">
                <div className="col-md-4">
                    <DownstairsPlan rooms_ids={downstairs_rooms_ids} />
                </div>
                <div className="col-md-4">
                    <FirstFloorPlan rooms_ids={firstfloor_rooms_ids} />
                </div>
                <div className="col-md-4">
                    <TentPlan rooms_ids={tent_rooms_ids} />
                </div>


            </div>
        )

    }

    print(){
        window.print();
    }

    public render () {

        return(
            <div className="box">
                <div className="box-header">
                    <h3 className="box-title">Elérhető szállások</h3>
                </div>

                <div className="box-body table-responsive" style={{position: 'relative'}}>
                    <div className = "row">
                        <div className = "col-md-8 col-md-offset-2">
                            <div className="row">

                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        Érkezés:
                                    </span>
                                        <input type="date" name="arrival_date" className="form-control" onChange={(e) => this.updateDates(e, 'from')} required />
                                    </div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        Távozás:
                                    </span>
                                        <input type="date" name="departure_date" className="form-control" onChange={(e) => this.updateDates(e, 'to')} required />
                                    </div>
                                </div>
                            </div>
                            {
                                Object.keys(this.state.places).length > 0 &&
                                <>
                                    <div className="row" style = {{display: 'flex', justifyContent: 'center'}}>
                                        <div style ={{width: 'auto', marginRight: '15px', marginBottom: '10px', background: '#febf0f', color: '#fff'}} className="form-control pull-right">
                                            <i className="fa fa-bed"></i> Elérhető férőhely: {this.state.sumplaces} fő
                                        </div>
                                    </div>
                                    {this.Rooms()}
                                    <div className="row">
                                        <div className="col-md-12"  style = {{display: "flex", justifyContent: "center"}}>
                                            <button type = "button" className="btn btn-lg btn-success" onClick={() => this.print()}>Nyomtatás</button>
                                        </div>
                                    </div>
                                </>

                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
